export default {
  setHeadersEtag (state, { url, headers }) {
    const eTagHeader = headers && headers.etag
    state.headersEtag = {
      ...state.headersEtag,
      [url]: eTagHeader || ''
    }
  }
}
